var playing = false;
var playingButton;
var audio = document.getElementById('audio');
var hls;
var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

document.querySelectorAll('tbody td.fixed-column').forEach(cell => {
    var height = cell.getBoundingClientRect().height - 2 * 14;
    [...cell.parentNode.children].forEach(cell2 => {
        cell2.height = height;
    });
});

let controller = null;
let signal = null;
let timeout = null;
document.querySelectorAll('a.icon-play').forEach(button => {
    button.addEventListener('click', (event) => {
        event.preventDefault();

        document.getElementById('current-metadata-wrapper').style.display = 'none';

        if (button.classList.contains('icon-stop')) {
            stopStream();
        }
        else {
            if (playing) {
                stopStream();
            }

            if (typeof Hls === 'undefined') {
                audio.src = button.href;
                audio.load();
                audio.play();

                if (controller) {
                    controller.abort();
                }
                if (timeout) {
                    clearTimeout(timeout);
                }

                controller = new AbortController();
                const { signal } = controller;

                let ep    = button.dataset.ep || 0;
                let mount = button.dataset.mount ||'';
                
                fetchMetadata(ep, mount, audio.src);
            }
            else {
                if (Hls.isSupported() && !is_safari) {
                    hls = new Hls();
                    hls.loadSource(button.href);
                    hls.attachMedia(audio);
                    hls.on(Hls.Events.MANIFEST_PARSED, function() {
                        audio.play();
                    });
                    hls.on(Hls.Events.MEDIA_ATTACHED, function() {
                        hls.on(Hls.Events.FRAG_PARSING_METADATA, function(event, data, x) {
                            data.samples.forEach(function (sample) {
                                let id3Data = ID3.getID3Data(sample.data, 0);
                                let frames = ID3.getID3Frames(id3Data);
                                // console.log(frames);

                                let metadata = [];
                                frames.forEach(function (frame) {
                                    if (frame.key === 'TIT2' || frame.key === 'TPE1') {
                                        metadata.push(frame.key + ': ' + frame.data);
                                    }
                                });
                                showMetadata(button.dataset.mount, button.dataset.ep, metadata.join(', '));
                            });
                        });
                    });
                }
                else if (audio.canPlayType('application/vnd.apple.mpegurl')) {
                    audio.src = button.href;
                    audio.addEventListener('loadedmetadata', function() {
                        audio.play();
                    });

                    audio.textTracks.addEventListener('addtrack', function(addTrackEvent) {
                        var track = addTrackEvent.track;
                        track.mode = 'hidden';

                        track.addEventListener('cuechange', function(cueChangeEvent) {
                            if (track.activeCues.length <= 0) {
                                return; // there is not active metadata at the moment.
                            }

                            // console.log(track.activeCues);

                            let metadata = [];
                            [...track.activeCues].forEach(function (cue) {
                                if (cue.value.key === 'TIT2' || cue.value.key === 'TPE1') {
                                    metadata.push(cue.value.key + ': ' + cue.value.data);
                                }
                            });
                            showMetadata(button.dataset.mount, button.dataset.ep, metadata.join(', '));
                        });
                    });
                }
            }

            playing = true;
            playingButton = button;
            button.classList.remove('icon-play');
            button.classList.add('icon-stop');
        }
    });
});

function stopStream() {
    audio.pause();
    audio.src = '/assets/audio/blank.mp3';

    if (typeof hls !== 'undefined') {
        hls.destroy();
    }

    playing = false;
    playingButton.classList.remove('icon-stop');
    playingButton.classList.add('icon-play');

    controller = null;
    clearTimeout(timeout);
}

function fetchMetadata(ep, mount, stream_url) {
    fetch('/metadata/' + ep + '/' + mount + '?extract=' + stream_url, { signal }).then(function (response) {
        if (response.ok) {
            return response.json();
        }
        else {
            return Promise.reject(response);
        }
    }).then(function (data) {
        showMetadata(data.mount, data.ep, data.metadata || '', data.info);

        controller = null;
        clearTimeout(timeout);

        timeout = setTimeout(() => {
            fetchMetadata(ep, mount, stream_url);
        }, 10000);
    }).catch(function (err) {
        controller = null;

        if (err.name === "AbortError") {
            console.warn('fetch aborted');
        }
        else {
            console.warn('Something went wrong.', err);
        }
    });
}

function showMetadata(mount, ep, metadata, info) {
    let string = 'Current metadata for <strong>' + mount + '</strong> on <strong>EP ' + ep + '</strong>:<br><strong>' + metadata + '</strong>';
    if (typeof info !== 'undefined' && info !== null) {
        string += '<br>' + info;
    }
    document.getElementById('current-metadata').innerHTML = string;
    document.getElementById('current-metadata-wrapper').style.display = 'block';
}